import { Injectable } from '@angular/core';
import { IWebAuthData, IWebAuthSessionData } from '../../shared/models';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import {
  WebAuthRemoveAction,
  WebAuthSaveAction,
  WebAuthUpdateDataAction,
  WebAuthUpdateSessionDataAction,
} from '../../actions/webauth.actions';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { initialState } from '../../reducers/webauth.reducer';

const CACHE_EXPIRATION_MS = 15 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class WebAuthService {
  constructor(private store: Store<fromRoot.State>) {}

  public updateWebAuthData(data: Partial<IWebAuthData>): void {
    this.store.dispatch(new WebAuthUpdateDataAction({ data }));
  }

  public updateWebAuthSessionData(data: IWebAuthSessionData): void {
    this.store.dispatch(new WebAuthUpdateSessionDataAction({ data }));
  }
  public saveWebAuthData(data: IWebAuthData): void {
    this.store.dispatch(new WebAuthSaveAction({ webAuthData: data }));
  }

  public clearWebAuthData(): void {
    this.store.dispatch(new WebAuthRemoveAction());
  }

  public getWebAuthState$(): Observable<{ webAuthData: IWebAuthData; sessionData: IWebAuthSessionData }> {
    return this.store.select(fromRoot.getWebAuthState).pipe(
      tap((state) => {
        if (state?.webAuthData && this.isExpired(state.webAuthData.timestamp)) {
          this.clearWebAuthData();
        }
      }),
      map((state) => {
        if (state?.webAuthData && this.isExpired(state.webAuthData.timestamp)) {
          return initialState;
        }
        return state;
      }),
    );
  }

  private isExpired(timestamp: number | undefined): boolean {
    if (!timestamp) return false;
    return Date.now() - timestamp > CACHE_EXPIRATION_MS;
  }
}
